/* eslint-disable import/prefer-default-export */
import { AppActionCreators, AppActionTypes } from './types';

export const setFirstPageView = (firstPageView: boolean): AppActionCreators => {
  return { type: AppActionTypes.SET_FIRST_PAGEVIEW, firstPageView };
};
